import { render } from "./UserSetupComponent.vue?vue&type=template&id=394e7a21&scoped=true"
import script from "./UserSetupComponent.vue?vue&type=script&lang=js"
export * from "./UserSetupComponent.vue?vue&type=script&lang=js"

import "./UserSetupComponent.vue?vue&type=style&index=0&id=394e7a21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394e7a21"]])

export default __exports__